import { useIntl } from 'react-intl'

import PromotionLabel from 'LuxKit/Label/PromotionLabel'

function AgentExclusivePackageLabel() {
  const intl = useIntl()

  return (
    <PromotionLabel>
      {intl.formatMessage({
        id: '4Np3x1K3ULje-ysswXzJ',
        defaultMessage: 'Agent Exclusive Package',
      })}
    </PromotionLabel>
  )
}

export default AgentExclusivePackageLabel
